import axios from "axios";

export default {
  CREATE_PROJECT(context, { data }) {
    context.commit("PROJECTS__UPDATE_LOADING", true);
    axios
      .post(`${context.getters.getUrl}/v1/Projects`, data)
      .then((response) => {
        context.commit("PROJECTS__REFRESH_LIST");
        context.dispatch("DISPLAY_MESSAGE", response.data);
      })
      .catch((error) => {
        console.log(error);
      })
      .finally(() => {
        context.commit("PROJECTS__UPDATE_LOADING", false);
      });
  },
  UPDATE_PROJECT(context, { id, data }) {
    context.commit("PROJECTS__UPDATE_LOADING", true);
    axios
      .put(`${context.getters.getUrl}/v1/Projects/${id}`, data)
      .then((response) => {
        context.commit("PROJECTS__REFRESH_LIST");
        context.dispatch("DISPLAY_MESSAGE", response.data);
      })
      .catch((error) => {
        console.log(error);
      })
      .finally(() => {
        context.commit("PROJECTS__UPDATE_LOADING", false);
      });
  },
  DELETE_PROJECT(context, { id, language = 0 }) {
    context.commit("PROJECTS__UPDATE_LOADING", true);
    context.commit("PROJECTS__UPDATE_ITEM", undefined);
    axios
      .delete(`${context.getters.getUrl}/v1/Projects/${id}`, {
        params: {
          language,
        },
      })
      .then((response) => {
        context.commit("PROJECTS__REFRESH_LIST");
        context.dispatch("DISPLAY_MESSAGE", response.data);
      })
      .catch((error) => {
        console.log(error);
      })
      .finally(() => {
        context.commit("PROJECTS__UPDATE_LOADING", false);
      });
  },
  async GET_PROJECT(context, { id, language = 0 }) {
    context.commit("PROJECTS__UPDATE_LOADING", true);
    context.commit("PROJECTS__UPDATE_ITEM", undefined);
    try {
      let response = await axios.get(
        `${context.getters.getUrl}/v1/Projects/${id}`,
        {
          params: {
            language,
          },
        }
      );
      context.commit("PROJECTS__UPDATE_ITEM", response.data);
      return response.data;
    } catch (error) {
      console.log(error);
    } finally {
      context.commit("PROJECTS__UPDATE_LOADING", false);
    }
  },
  GET_PROJECTS(context, payload) {
    context.commit("PROJECTS__UPDATE_LIST_LOADING", true);
    context.commit("PROJECTS__UPDATE_PAGE_NO", payload.page);
    context.commit("PROJECTS__UPDATE_PAGE_SIZE", payload.count);
    axios
      .get(`${context.getters.getUrl}/v1/Projects`, {
        params: {
          page: payload.page,
          count: payload.count,
          language: payload.language,
          phrase: payload.phrase,
          customerId: payload.customerId,
        },
      })
      .then((response) => {
        context.commit("PROJECTS__UPDATE_LIST", response.data.items);
        context.commit("PROJECTS__UPDATE_TOTAL", response.data.count);
      })
      .catch((error) => {
        context.state.items = [];
        console.log(error);
      })
      .finally(() => {
        context.commit("PROJECTS__UPDATE_LIST_LOADING", false);
      });
  },
  async GET_PROJECT_GROUP(context, { id }) {
    context.commit("PROJECTS__UPDATE_GROUPS_LOADING", true);
    try {
      let response = await axios.get(
        `${context.getters.getUrl}/v1/ProjectGroups/${id}`
      );
      context.commit("PROJECTS__UPDATE_ITEM", response.data);
      return response.data;
    } catch (error) {
      console.log(error);
    } finally {
      context.commit("PROJECTS__UPDATE_GROUPS_LOADING", false);
    }
  },
  CREATE_PROJECT_GROUP(context, { data }) {
    context.commit("PROJECTS__UPDATE_GROUPS_LOADING", true);
    axios
      .post(`${context.getters.getUrl}/v1/ProjectGroups`, data)
      .then((response) => {
        context.commit("PROJECTS__REFRESH_GROUPS_LIST");
        context.dispatch("DISPLAY_MESSAGE", response.data);
      })
      .catch((error) => {
        console.log(error);
      })
      .finally(() => {
        context.commit("PROJECTS__UPDATE_GROUPS_LOADING", false);
      });
  },
  UPDATE_PROJECT_GROUP(context, { id, data }) {
    context.commit("PROJECTS__UPDATE_GROUPS_LOADING", true);
    axios
      .put(`${context.getters.getUrl}/v1/ProjectGroups/${id}`, data)
      .then((response) => {
        context.commit("PROJECTS__REFRESH_GROUPS_LIST");
        context.dispatch("DISPLAY_MESSAGE", response.data);
      })
      .catch((error) => {
        console.log(error);
      })
      .finally(() => {
        context.commit("PROJECTS__UPDATE_GROUPS_LOADING", false);
      });
  },
  DELETE_PROJECT_GROUP(context, { id }) {
    context.commit("PROJECTS__UPDATE_GROUPS_LOADING", true);
    axios
      .delete(`${context.getters.getUrl}/v1/ProjectGroups/${id}`)
      .then((response) => {
        context.commit("PROJECTS__REFRESH_GROUPS_LIST");
        context.dispatch("DISPLAY_MESSAGE", response.data);
      })
      .catch((error) => {
        console.log(error);
      })
      .finally(() => {
        context.commit("PROJECTS__UPDATE_GROUPS_LOADING", false);
      });
  },
  GET_PROJECT_GROUPS(context, payload) {
    context.commit("PROJECTS__UPDATE_GROUPS_LIST_LOADING", true);
    context.commit("PROJECTS__UPDATE_GROUPS_PAGE_NO", payload.page);
    context.commit("PROJECTS__UPDATE_GROUPS_PAGE_SIZE", payload.count);
    axios
      .get(`${context.getters.getUrl}/v1/ProjectGroups`, {
        params: {
          page: payload.page,
          count: payload.count,
          phrase: payload.phrase,
          language: payload.language,
        },
      })
      .then((response) => {
        context.commit("PROJECTS__UPDATE_GROUPS_LIST", response.data.items);
        context.commit("PROJECTS__UPDATE_GROUPS_TOTAL", response.data.count);
      })
      .catch((error) => {
        context.commit("PROJECTS__UPDATE_GROUPS_LIST", []);
        console.log(error);
      })
      .finally(() => {
        context.commit("PROJECTS__UPDATE_GROUPS_LIST_LOADING", false);
      });
  },
};
